<main class="account-blocked" id="main-content" tabindex="-1">
  <div class="account-blocked__panel">
    <h1 class="account-blocked__title">Access unavailable</h1>
    <p class="account-blocked__message">{{ message() }}</p>
    <button cdsButton="primary" type="button" (click)="logout()">Log out</button>
  </div>
</main>
